import type { ShouldRevalidateFunction } from 'react-router';
import type { LoaderFunctionArgs } from '~/types/route-args';
import { getRecentMagazines } from '~/modules/magazine/api/get-recent-magazines.server';

export const RECENT_MAGAZINES_API_ROUTE = '/remix-api/recent-magazines';

/** How many magazine covers the "Stay in the loop" carousel pulls. */
const RECENT_MAGAZINES_LIMIT = 8;

/**
 * GET endpoint returning the latest digital magazines (cover + link) for the US
 * Products "Coming Soon" page's "Stay in the loop" carousel. Read client-side
 * via useFetcher().load() so the shared /products loader stays untouched.
 */
export const loader = async ({ context }: LoaderFunctionArgs) => {
    const { magazines } = await getRecentMagazines({
        ...context,
        limit: RECENT_MAGAZINES_LIMIT,
    });
    return { magazines };
};

export const shouldRevalidate: ShouldRevalidateFunction = () => false;
